export const NAVIGATION_MENU = [
  {
    link: '/',
    label: 'Dashboard',
    icon: 'DashboardIcon',
    permission: null,
    hasChildren: false,
  },
  {
    link: '/landing-page',
    label: 'Landing Page',
    icon: 'LandingPageIcon',
    arrow: true,
    permission: 'landing-page.manage',
    hasChildren: false,
  },
  {
    link: '/layanan',
    label: 'Layanan',
    icon: 'ServiceIcon',
    arrow: true,
    permission: null,
    hasChildren: false,
  },
  {
    link: '/agenda-v2',
    label: 'Agenda',
    icon: 'AgendaIcon',
    permission: null,
    hasChildren: false,
  },
  {
    link: '/berita-dan-artikel',
    label: 'Berita dan Artikel',
    icon: 'NewsIcon',
    arrow: true,
    permission: null,
    hasChildren: false,
  },
  {
    link: '/profil-jawa-barat',
    label: 'Profil Jawa Barat',
    icon: 'GedungSateIcon',
    arrow: true,
    permission: 'profile-west-java.manage',
    hasChildren: true,
    children: [
      {
        link: '/profil-jawa-barat/tentang',
        label: 'Tentang Jawa Barat',
        permission: 'profile-west-java.manage',
      },
      {
        link: '/profil-jawa-barat/selayang-pandang',
        label: 'Selayang Pandang',
        permission: 'profile-west-java.manage',
      },
      {
        link: '/profil-jawa-barat/arsip-dan-dokumen',
        label: 'Arsip dan Dokumen',
        permission: 'profile-west-java.manage',
      },
    ],
  },
];

// @TODO: Remove old agenda if the agenda v2 is steady
export const AGENDA_TABLE_HEADER = [
  {
    key: 'title',
    text: 'Judul Agenda/Event',
    sortable: true,
  },
  {
    key: 'category',
    text: 'Ketegori',
    sortable: true,
  },
  {
    key: 'date',
    text: 'Tanggal',
    sortable: true,
  },
  {
    key: 'time',
    text: 'Waktu',
    sortable: true,
  },
  {
    key: 'type',
    text: 'Tipe Agenda',
    sortable: true,
  },
  {
    key: 'action',
    text: 'Aksi',
  },
];

export const AGENDA_TABLE_HEADER_V2 = [
  {
    key: 'title',
    text: 'Judul Agenda/Event',
    sortable: true,
  },
  {
    key: 'is_pinned',
    text: 'Sematan',
    sortable: true,
  },
  {
    key: 'category',
    text: 'Kategori',
    sortable: true,
  },
  {
    key: 'date',
    text: 'Tanggal',
    sortable: true,
  },
  {
    key: 'time',
    text: 'Waktu',
    sortable: true,
  },
  {
    key: 'type',
    text: 'Tipe Agenda',
    sortable: true,
  },
  {
    key: 'availability',
    text: 'Sifat Acara',
    sortable: true,
  },
  {
    key: 'action',
    text: 'Aksi',
  },
];

export const AGENDA_CATEGORIES = [
  {
    label: 'Gubernur',
    value: 'Gubernur',
  },
  {
    label: 'Wakil Gubernur',
    value: 'Wakil Gubernur',
  },
  {
    label: 'Istri Gubernur',
    value: 'Istri Gubernur',
  },
  {
    label: 'PJ Gubernur',
    value: 'PJ Gubernur',
  },
  {
    label: 'Istri PJ Gubernur',
    value: 'Istri PJ Gubernur',
  },
  {
    label: 'Sekretaris Daerah',
    value: 'Sekretaris Daerah',
  },
  {
    label: 'Plh Sekretaris Daerah',
    value: 'Plh Sekretaris Daerah',
  },
  {
    label: 'OPD',
    value: 'OPD',
  },
  {
    label: 'Event Jawa Barat',
    value: 'Event Jawa Barat',
  },
];

export const AGENDA_V2_CATEGORIES = Object.freeze({
  Pimpinan: ['Gubernur', 'Wakil Gubernur', 'Sekretaris Daerah', 'Ketua TP-PKK', 'Pj Gubernur', 'Plh Sekretaris Daerah', 'Pj Ketua TP-PKK'],
  'Perangkat Daerah': ['Seremoni', 'Program Unggulan', 'Kegiatan Umum'],
  Umum: ['Hiburan', 'Pendidikan', 'Sosial Budaya', 'Olahraga', 'Lingkungan'],
});

export const AGENDA_TYPES = [
  {
    label: 'Agenda Offline',
    value: 'offline',
  },
  {
    label: 'Agenda Online',
    value: 'online',
  },
];

export const AGENDA_STATUS_MAP = {
  publish: 'Telah Dipublish',
  unpublish: 'Belum Dipublish',
  archive: 'Dibuang',
};

export const NEWS_CATEGORIES = [
  {
    value: 'ekonomi',
    label: 'Ekonomi',
  },
  {
    value: 'kesehatan',
    label: 'Kesehatan',
  },
  {
    value: 'pendidikan',
    label: 'Pendidikan',
  },
  {
    value: 'pemerintahan',
    label: 'Pemerintahan',
  },
  {
    value: 'infrastruktur',
    label: 'Infrastruktur',
  },
  {
    value: 'sosial',
    label: 'Sosial',
  },
  {
    value: 'teknologi',
    label: 'Teknologi',
  },
];

export const NEWS_DURATION = [
  {
    label: '5 Hari',
    value: 5,
  },
  {
    label: '1 Minggu',
    value: 7,
  },
  {
    label: '2 Minggu',
    value: 14,
  },
  {
    label: 'Tanpa Batas',
    value: -1,
  },
];

export const NEWS_TABLE_HEADER = [
  {
    key: 'title',
    text: 'Judul Berita',
    sortable: true,
  },
  {
    key: 'category',
    text: 'Kategori',
    sortable: true,
  },
  {
    key: 'created_by',
    text: 'Dibuat oleh',
    sortable: true,
  },
  {
    key: 'updated_at',
    text: 'Terakhir Diupdate',
    sortable: true,
  },
  {
    key: 'status',
    text: 'Status',
    sortable: true,
  },
  {
    key: 'action',
    text: 'Aksi',
  },
];

export const NEWS_STATUS_MAP = {
  PUBLISHED: 'Diterbitkan',
  DRAFT: 'Tersimpan',
  ARCHIVED: 'Diarsipkan',
  REVIEW: 'Menunggu Review',
};

export const MEMBER_TABLE_HEADER = [
  {
    key: 'name',
    text: 'Nama',
    // sortable: true,
  },
  {
    key: 'email',
    text: 'Email',
    // sortable: true,
  },
  {
    key: 'unit_name',
    text: 'Unit/Organisasi',
    // sortable: true,
  },
  {
    key: 'role',
    text: 'Keanggotaan',
    // sortable: true,
  },
  {
    key: 'last_active',
    text: 'Terakhir Aktif',
    // sortable: true,
  },
  {
    key: 'status',
    text: 'Status',
    // sortable: true,
  },
  {
    key: 'action',
    text: 'Aksi',
  },
];

export const POPUP_BANNER_TABLE_HEADER = [
  {
    key: 'title',
    text: 'Judul Banner',
  },
  {
    key: 'preview',
    text: 'Preview',
  },
  {
    key: 'link',
    text: 'Link Button',
  },
  {
    key: 'duration',
    text: 'Durasi Penayangan',
  },
  {
    key: 'start_date',
    text: 'Waktu Mulai Penayangan',
  },
  {
    key: 'status',
    text: 'Status',
  },
  {
    key: 'action',
    text: 'Aksi',
  },
];

export const POPUP_BANNER_SCHEDULE_OPTIONS = [
  {
    label: '2 Hari',
    value: 2,
  },
  {
    label: '5 Hari',
    value: 5,
  },
  {
    label: '7 Hari',
    value: 7,
  },
  {
    label: '14 Hari',
    value: 14,
  },
  {
    label: '30 Hari',
    value: 30,
  },
  {
    label: 'Atur Durasi Manual',
    value: 999,
  }
];

export const STATUS_MODAL = {
  NONE: 'NONE',
  CONFIRMATION: 'CONFIRMATION',
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};

export const MASTER_DATA_TABLE_HEADER = [
  {
    key: 'title',
    text: 'Nama Layanan',
    sortable: false,
  },
  {
    key: 'author',
    text: 'Author',
    sortable: false,
  },
  {
    key: 'user',
    text: 'Pengguna Layanan',
    sortable: false,
  },
  {
    key: 'technical',
    text: 'Teknis Layanan',
    sortable: false,
  },
  {
    key: 'updated',
    text: 'Diperbarui',
    sortable: false,
  },
  {
    key: 'status',
    text: 'Status',
    sortable: false,
  },
  {
    key: 'action',
    text: 'Aksi',
    sortable: false,
  },
];

export const MASTER_DATA_STATUS_MAP = {
  ALLSERVICES: 'Semua Layanan',
  DRAFT: 'Draf',
  ARCHIVE: 'Tersimpan',
};

export const PUBLICATION_TABLE_HEADER = [
  {
    key: 'title',
    text: 'Nama Layanan',
    sortable: false,
  },
  {
    key: 'author',
    text: 'Author',
    sortable: false,
  },
  {
    key: 'user',
    text: 'Pengguna Layanan',
    sortable: false,
  },
  {
    key: 'technical',
    text: 'Teknis Layanan',
    sortable: false,
  },
  {
    key: 'updated',
    text: 'Diperbarui',
    sortable: false,
  },
  {
    key: 'status',
    text: 'Status',
    sortable: false,
  },
  {
    key: 'action',
    text: 'Aksi',
    sortable: false,
  },
];

export const PUBLICATION_STATUS_MAP = {
  ALLSERVICES: 'Semua Layanan',
  //  @NOTE: In publication status Archive property have an value or label in User as Draf
  ARCHIVE: 'Draf',
  PUBLISH: 'Terbit',
};

export const DAY_MAP = {
  MONDAY: 'Senin',
  TUESDAY: 'Selasa',
  WEDNESDAY: 'Rabu',
  THURSDAY: 'Kamis',
  FRIDAY: 'Jumat',
  SATURDAY: 'Sabtu',
  SUNDAY: 'Minggu',
};

export const INFO_GRAPHICS_BANNER_TABLE_HEADER = [
  {
    key: 'title',
    text: 'Judul Banner',
  },
  {
    key: 'preview',
    text: 'Preview',
  },
  {
    key: 'sequence',
    text: 'Urutan',
  },
  {
    key: 'link',
    text: 'Link Redirect',
  },
  {
    key: 'status',
    text: 'Status',
  },
  {
    key: 'action',
    text: 'Aksi',
  },
];

export const QUICK_LINK_TABLE_HEADER = [
  {
    key: 'title',
    text: 'Judul Program',
  },
  {
    key: 'preview',
    text: 'Preview',
  },
  {
    key: 'link',
    text: 'Link Redirect',
  },
  {
    key: 'status',
    text: 'Status',
  },
  {
    key: 'action',
    text: 'Aksi',
  },
];

export const DOCUMENT_TABLE_HEADER = [
  {
    key: 'title',
    text: 'Judul Dokumen',
    sortable: false,
  },
  {
    key: 'category',
    text: 'Kategori',
    sortable: false,
  },
  {
    key: 'status',
    text: 'Status',
    sortable: false,
  },
  {
    key: 'updated',
    text: 'Terakhir Diupdate',
    sortable: false,
  },
  {
    key: 'document_year',
    text: 'Tahun Dokumen',
    sortable: false,
  },
  {
    key: 'action',
    text: 'Aksi',
    sortable: false,
  },
];

export const DOCUMENT_STATUS_MAP = {
  DRAFT: 'Draf',
  ARCHIVED: 'Diarsipkan',
  PUBLISHED: 'Terbit',
};

export const DOCUMENT_STATUS_ADDITIONAL_BUTTON = {
  DRAFT: 'Terbitkan',
  ARCHIVED: 'Pulihkan',
  PUBLISHED: 'Arsipkan',
};

export const DOCUMENT_CATEGORIES = [
  {
    value: 'Dokumen Perencanaan',
    label: 'Dokumen Perencanaan',
  },
  {
    value: 'Laporan Pertanggungjawaban',
    label: 'Laporan Pertanggungjawaban',
  },
  {
    value: 'Produk Hukum',
    label: 'Produk Hukum',
  },
  {
    value: 'Transparansi Kepegawaian',
    label: 'Transparansi Kepegawaian',
  },
  {
    value: 'Transparansi Pengelolaan Keuangan Daerah',
    label: 'Transparansi Pengelolaan Keuangan Daerah',
  },
];

export const DATA_NOT_FOUND_STATE = {
  image: require('@/assets/icons/search-not-found.svg'),
  alternateImage: 'gambar dokumen dengan kaca pembesar',
  width: 140,
  height: 140,
  title: 'Data tidak ditemukan !',
  description: 'Data yang Kamu minta tidak dapat ditemukan. Mohon pastikan Kamu telah memasukkan informasi yang benar.',
};

export const DISTRICT_TABLE_HEADER = [
  {
    key: 'name',
    text: 'Nama Kabupaten/Kota',
    sortable: false,
  },
  {
    key: 'logo',
    text: 'Logo',
    sortable: false,
  },
  {
    key: 'chief',
    text: 'Nama Pimpinan',
    sortable: false,
  },
  {
    key: 'address',
    text: 'Alamat',
    sortable: false,
  },
  {
    key: 'link',
    text: 'Link Website',
    sortable: false,
  },
  {
    key: 'action',
    text: 'Aksi',
    sortable: false,
  },
];

export const UNIT_TABLE_HEADER = [
  {
    key: 'name',
    text: 'Nama Perangkat Daerah',
    sortable: false,
  },
  {
    key: 'logo',
    text: 'Logo',
    sortable: false,
  },
  {
    key: 'chief',
    text: 'Nama Pimpinan',
    sortable: false,
  },
  {
    key: 'phone',
    text: 'No Telepon',
    sortable: false,
  },
  {
    key: 'address',
    text: 'Alamat',
    sortable: false,
  },
  {
    key: 'website',
    text: 'Link Website',
    sortable: false,
  },
  {
    key: 'action',
    text: 'Aksi',
    sortable: false,
  },
];
